<template xmlns="http://www.w3.org/1999/html">
  <div>
    <va-modal
      :value="isOpen"
      id="createRuleModal"
      ref="createRuleModal"
      :cancelText="$t('leads.back')"
      :okText="$t('modals.buttons.submit')"
      size="large"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
      @cancel="$emit('cancel')"
      @ok="handleSubmit"
      :okDisabled="isSubmitting || !canSubmit">
      <div slot="header" class="modal-title d-flex justify--space-between">
        <h3>{{$t('checkup_plus.person.rules.create_rule')}}</h3>
      </div>
      <div v-if="isLoading">
        <LoadingAnimation/>
      </div>
      <div v-else>
        <div class="row col-12">
          <span class="is-bold label"> {{$t('agenda.appointments.pacient')}}: </span>
          <span class="label">&ensp; {{ handlePersonName }} </span>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mt-4">
            <label class="form-label">{{ $t('checkup_plus.person.rules.rule_creation.measurement') }}</label>
            <multiselect
              id="measurementMultiselect"
              v-model="formData.measurementGroup"
              :options="measurementGroupOptions"
              :placeholder="$t('checkup_plus.person.rules.rule_creation.measurement')"
              trackBy="idMeasurementGroup"
              :customLabel="(elem) => $t(`checkup_plus.person.rules.rule_creation.measurement_group.${elem.idMeasurementGroup}`)"
              :multiple="false"
              :allowEmpty="false"
            >
            </multiselect>
          </div>
          <div class="col-12 col-md-6  mt-4">
            <label class="form-label">{{ $t('checkup_plus.person.rules.limitType.title') }}</label>
            <multiselect
              id="measurementMultiselect"
              v-model="formData.limitType"
              :options="limitTypesOptions"
              :placeholder="$t('checkup_plus.person.rules.limitType.title')"
              trackBy="id"
              :customLabel="(elem) => $t(elem.translationKey)"
              :multiple="false"
              :allowEmpty="false"
            >
            </multiselect>
          </div>
          <div class="col-12 col-md-6  mt-4">
            <label class="form-label">{{ $t('checkup_plus.person.rules.rule_creation.criteria') }}</label>
            <multiselect
              id="limitTypeMultiselect"
              v-model="formData.criteria"
              :options="formData.measurementGroup ? formData.measurementGroup.chartResults : []"
              :placeholder="$t('checkup_plus.person.rules.rule_creation.criteria')"
              trackBy="id"
              :customLabel="(elem) => handleCriteriaLabel(elem)"
              :multiple="false"
              :allowEmpty="false"
              :max-height="15"
              :disabled="formData.measurementGroup === null"
            >
            </multiselect>
          </div>
        </div>

        <div class="row col-12 mt-4">
          <span class="is-bold label">Emails: </span>
        </div>
        <div class="row col-12">

          <p></p>
          <ul class="vue-unordered"><h6 v-if="formData.emails > 0">{{ $t('leads.recipients') }}:</h6>
            <li v-for="(email, index) in formData.emails" :key="index">
              {{ email }} &nbsp;
              <i class="email-notification-icon fa fa-times clickable alert-danger" @click="formData.emails.splice(index, 1)"></i>
            </li>
          </ul>
          <div class="row col-12 form-group with-icon-right" style="margin-bottom:1.5rem;" :class="{'has-error': invalidEmail && editingEmail !== '', 'valid': !invalidEmail && editingEmail !== ''}">
            <div class="input-group col-8">
              <va-input
                id="successfulEmail"
                name="successfulEmail"
                v-model="editingEmail"
                @keyup.enter="addEmail"
                label="Email"
                placeholder="Email"
                :success="editingEmail !== '' && !invalidEmail"
                :error="invalidEmail"
                :error-messages="[$t('users.inputs.invalid_email')]"
              />
            </div>
            <va-button :disabled="this.invalidEmail || this.editingEmail === ''" @click.prevent="addEmail"> {{$t('leads.details.add')}}

            </va-button>
          </div>
        </div>

        <div class="row col-12 mt-4 mb-5">
          <va-input
            id="textInput"
            :maxlength="255"
            :label="$t('checkup_plus.person.rules.rule_creation.message_body')"
            v-model="formData.text"
            :placeholder="$t('checkup_plus.person.rules.rule_creation.message_body')"
          >
          </va-input>
        </div>
      </div>
    </va-modal>


  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation.vue";
import {OneCareService} from "@/api/OneCareService";
import { EMAIL_REGEX } from '@/utils/regex';
export default {
  props:{
    person: {
      type: Object,
      required: true
    },
    allowedMeasurementGroups: {
      type: Array,
      required: true,
      default: []
    }
  },
  components: {LoadingAnimation, Multiselect},
  data: function() {
    return {
      isOpen: false,
      isLoading: false,
      isSubmitting: false,
      editingEmail: '',
      formData: {
        measurementGroup: null,
        limitType: null,
        alarmTypeId: null,
        criteria: null,
        text: '',
        emails: []
      },
      limitTypesOptions: [
        {
          id: 1,
          translationKey: 'checkup_plus.person.rules.rule_creation.limit_types_options.1'
        },
        {
          id: 2,
          translationKey: 'checkup_plus.person.rules.rule_creation.limit_types_options.2'
        },
        {
          id: 3,
          translationKey: 'checkup_plus.person.rules.rule_creation.limit_types_options.3'
        },
      ],
      measurementGroupOptions: []

    }
  },
  async mounted() {
    this.isOpen = true
    //load options
    this.isLoading = true
    const limitRulesOpts = await OneCareService.getLimitRulesOptions()
    this.measurementGroupOptions = limitRulesOpts.filter(elem => this.allowedMeasurementGroups.some(mgroup => elem.idMeasurementGroup === mgroup.measurementGroupId))
    this.isLoading = false

  },
  methods: {
    addEmail: function () {
      if (this.invalidEmail || this.editingEmail === '') return
      this.formData.emails.push(this.editingEmail.toLowerCase())
      this.editingEmail = ''
    },
    handleCriteriaLabel: function(elem) {
      if(this.formData && this.formData.measurementGroup !== null && this.formData.measurementGroup.idMeasurementGroup === 5) {
        if(elem.id >= 20 && elem.id <= 25) {
          return this.$t(`dashboard_new_evollu.measurement_types.body_mass_index_short`) + " - " + this.$t(`dashboard_new_evollu.parameters.graphs.legends.${(elem.code).toLowerCase()}`)
        } else if (elem.id >= 26 && elem.id <= 28) {
          return this.$t(`dashboard_new_evollu.measurement_types.body_fat_percentage_short`) + " - " + this.$t(`dashboard_new_evollu.parameters.graphs.legends.${(elem.code).toLowerCase()}`)
        }
      }
      return this.$t(`dashboard_new_evollu.parameters.graphs.legends.${(elem.code).toLowerCase()}`)
    },
    handleSubmit: async function () {
      this.isSubmitting = true
      //TODO Test the following
      //Establish relation between caregiver and person
      try {
        await OneCareService.establishRelationBetweenCaregiverAndPerson(this.$auth.user().id, this.person.idPerson)
      } catch (err) {
        console.log(err)
        this.isSubmitting = false
        this.showToast(this.$t('checkup_plus.person.rules.rule_creation.errors.establish_relation_error'), this.$store.state.errorToastOptions)
        return
      }

      let data = {
        "entityEmails": this.formData.emails.join(";"),
        "limitRuleId": null,
        "measurementType": null,
        "limitType": {
          "limittypeId": this.formData.limitType.id,
          "name": null,
        },
        "alarmType": {
          "alarmTypeId": this.formData.measurementGroup.alarmTypeId
        },
        "priority": 1,
        "limitValue": null,
        "text": this.formData.text,
        "chartResult": {
          ...this.formData.criteria
        }
      }

      try {
        let createdRule = await OneCareService.createLimitRule(this.person.idPerson, data)
        this.$emit('ruleCreated', createdRule)
        this.isOpen = false
      } catch (err) {
        console.log(err)
        this.showToast(this.$t('checkup_plus.person.rules.rule_creation.errors.rule_creation_error'), this.$store.state.errorToastOptions)
      }
      this.isSubmitting = false
    },
  },
  computed: {
    handlePersonName: function() {
      let name= ''
      if(this.person.firstName) {
        name += this.person.firstName
      }
      if(this.person.surname) {
        name += ' '
        name += this.person.surname
      }
      return name
    },
    canSubmit: function() {
      return this.formData.measurementGroup !== null && this.formData.limitType !== null && this.formData.text !== '' && this.formData.text !== null && this.formData.criteria !== null
    },
    invalidEmail: function () {
      if (this.editingEmail) {
        return !this.editingEmail.match(EMAIL_REGEX)
      }
      return false
    },
  },
  watch: {
    'formData': {
      handler: function(value) {
        if(value.text === '') {
          if(value.criteria !== null && value.limitType !== null && value.measurementGroup !== null) {
            let text = `Alerta: `
            text+= this.$t(`checkup_plus.person.rules.rule_creation.measurement_group.${value.measurementGroup.idMeasurementGroup}`)
            text+= ` - ${this.$t(value.limitType.translationKey)}`
            text+= ` - ${this.$t(`dashboard_new_evollu.parameters.graphs.legends.${(value.criteria.code).toLowerCase()}`)}`
            this.formData.text = text
          } else {
            this.formData.text = ''
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
